module.exports = __webpack_public_path__ + "themes/mf/img/multiplier-x5.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/multiplier-x5.png
// module id = 84
// module chunks = 3